module.exports = "<header-mov></header-mov>\r\n<div class=\"principal\" fxLayout=\"row\">\r\n    <text-editor-mov fxFlex=\"80%\"></text-editor-mov>\r\n</div>"